import React, { Component } from "react";
import ReactDOM from "react-dom";

import styles from "../../../components/Client/styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";
import PROMO_A from "../../../assets/images/error-404.svg";
import {
  agreementVerification,
  saveVerificationAgreement,
  saveChooseSignatureAgreementVerification,
  downloadAgreementPdf,
} from "../../../config/client_api_calls";
import { REPLACECONTENTCLIENT } from "../../../config/utility";
import {
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
  APP_LIVE_URL,
  ADMIN_URL,
  LOGO,
} from "../../../config/config";
import "../../../components/Client/agreement.css";
import HelperClass from "../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import { tableLoaderAgreement } from "../../../components/ContentLoaders/table_loader_agreement";
import parsePhoneNumberFromString from "libphonenumber-js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as docx from "docx";
import NotificationToast from "../../../components/Notification/NotificationToast";

const auth = new HelperClass();
const {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  convertInchesToTwip,
} = docx;

export default class AgreementVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
      tableLoaderAgreement: true,
      errorMessageSignee: "",
      successMessageSignee: "",
      agreementData: [],
      replacable_content: "",
      final_content: "",
      agreement_id: "",
      agreement_accountno: "",
      agreement_title: "",
      signature_zero: 1,
      signature_one: 0,
      signature_two: 0,
      signature_three: 0,
      signature_four: 0,
      vendor_signature: "",
      agreement_type: "esign",
      is_checked: "",
      client_token: "",
      client_accountno: "",
      reseller_identifier: "",
      reseller_logo: "",
      signature_type: "draw",
      signatureText: "",
      signatureClass: "'Amita', cursive",
      button_submit_loader: false,
      file_type: "docx",
      scrollProgress: 0,
      hasReachedEndOnce: false,
      consentChecked: false,
      highlightConsent: false,
      inlineAtBottom: false,
      currentStep: 1,
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      signatureDataUrl: "",
      signatureDrawn: false,
      signatureColor: "#0F3A70",
      penWidth: 2,
      loadingButton: false,
      uploadedSignature: "",
      activeTabIndex: 0,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      downloading: false,
      downloadingFormat: "",
      downloadModalOpen: false,
      readFullscreenOpen: false,
      fullscreenAtBottom: false,
      fullscreenReadComplete: false,
      resellerData: [],
      clientData: [],
      isAlreadySigned: false,
    };
    this.penSizes = [
      { label: "Fine", penWidth: 1.5, dotSize: 3 },
      { label: "Medium", penWidth: 2, dotSize: 5 },
      { label: "Bold", penWidth: 3.5, dotSize: 7 },
    ];
    this.inkColors = [
      { name: "Navy", value: "#0F3A70" },
      { name: "Black", value: "#000000" },
      { name: "Blue", value: "#1a73e8" },
      { name: "Green", value: "#0d7c3f" },
    ];
    this.cursiveFonts = [
      { name: "Your Signature", value: "'Amita', cursive" },
      { name: "Your Signature", value: "'Bad Script', cursive" },
      { name: "Your Signature", value: "'Damion', cursive" },
      { name: "Your Signature", value: "'Dancing Script', cursive" },
      { name: "Your Signature", value: "'Felipa', cursive" },
      { name: "Your Signature", value: "'Julee', cursive" },
      { name: "Your Signature", value: "'Kaushan Script', cursive" },
      { name: "Your Signature", value: "'Lugrasimo', cursive" },
      { name: "Your Signature", value: "'Pacifico', cursive" },
      { name: "Your Signature", value: "'Sofia', cursive" },
      { name: "Your Signature", value: "'Yellowtail', cursive" },
    ];
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
  }

  cloneSignatureStrokes = (strokes = []) =>
    strokes.map((stroke) => stroke.map((point) => ({ ...point })));

  getSignatureStrokes = (pad) => {
    if (!pad || typeof pad.toData !== "function") {
      return [];
    }
    return this.cloneSignatureStrokes(pad.toData());
  };

  applySignatureStrokes = (pad, strokes = []) => {
    if (!pad) {
      return;
    }
    pad.clear();
    if (strokes.length > 0) {
      pad.fromData(this.cloneSignatureStrokes(strokes));
    }
  };

  // Properly resize canvas with device pixel ratio support
  resizeSignatureCanvas = (canvasRef, containerHeight = 120) => {
    if (!canvasRef || !canvasRef.canvas) return;
    
    const dpr = window.devicePixelRatio || 1;
    const canvas = canvasRef.canvas;
    const container = canvas.parentElement;
    
    if (!container) return;
    
    const rect = container.getBoundingClientRect();
    const width = rect.width;
    const height = containerHeight;
    
    // Set CSS size
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    
    // Set actual canvas resolution with DPR
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    
    // Scale context for DPR
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
  };

  // Export signature with proper DPR downscaling to prevent zoom effect
  getScaledSignatureDataUrl = (canvasRef) => {
    if (!canvasRef || !canvasRef.canvas) return "";

    const trimmedCanvas = canvasRef.getTrimmedCanvas();
    if (!trimmedCanvas || !trimmedCanvas.width || !trimmedCanvas.height) {
      return "";
    }

    const dpr = window.devicePixelRatio || 1;
    if (dpr === 1) {
      return trimmedCanvas.toDataURL("image/png");
    }

    // For high DPR, create properly scaled export
    const scaledCanvas = document.createElement("canvas");
    const scaledCtx = scaledCanvas.getContext("2d");

    const targetWidth = Math.max(1, Math.round(trimmedCanvas.width / dpr));
    const targetHeight = Math.max(1, Math.round(trimmedCanvas.height / dpr));
    scaledCanvas.width = targetWidth;
    scaledCanvas.height = targetHeight;

    scaledCtx.drawImage(
      trimmedCanvas,
      0,
      0,
      trimmedCanvas.width,
      trimmedCanvas.height,
      0,
      0,
      targetWidth,
      targetHeight
    );

    return scaledCanvas.toDataURL("image/png");
  };

  syncInlineSignatureState = () => {
    const hasSignature = this.inlineSignatureStrokes.length > 0;
    const signatureDataUrl =
      hasSignature && this.signaturePad
        ? this.getScaledSignatureDataUrl(this.signaturePad)
        : "";
    this.setState({
      signatureDrawn: hasSignature,
      signatureDataUrl,
    });
    this.updateSignaturePreviewInAgreement(signatureDataUrl);
  };

  handleInlineSignatureEnd = () => {
    this.inlineSignatureStrokes = this.getSignatureStrokes(this.signaturePad);
    this.syncInlineSignatureState();
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      const dataUrl = this.signaturePad.getTrimmedCanvas().toDataURL("image/png");
      if (dataUrl) this.updateSignaturePreviewInAgreement(dataUrl);
    }
  };

  handleInlineSignatureBegin = () => {
    if (this.state.signatureDataUrl) {
      this.inlineSignatureStrokes = [];
      this.setState({ signatureDataUrl: "" });
      this.updateSignaturePreviewInAgreement("");
    }
  };

  handleModalSignatureBegin = () => {
    if (this.state.modalCanvasEmpty) {
      this.setState({ modalCanvasEmpty: false });
    }
  };

  handleModalSignatureEnd = () => {
    this.modalSignatureStrokes = this.getSignatureStrokes(this.signaturePadModal);
    this.setState({
      modalCanvasEmpty: this.modalSignatureStrokes.length === 0,
    });
  };

  undoModalSignature = () => {
    if (!this.signaturePadModal) {
      return;
    }
    const currentStrokes = this.modalSignatureStrokes.length
      ? this.cloneSignatureStrokes(this.modalSignatureStrokes)
      : this.getSignatureStrokes(this.signaturePadModal);
    if (!currentStrokes.length) {
      this.setState({ modalCanvasEmpty: true });
      return;
    }
    currentStrokes.pop();
    this.modalSignatureStrokes = currentStrokes;
    this.applySignatureStrokes(this.signaturePadModal, currentStrokes);
    this.setState({ modalCanvasEmpty: currentStrokes.length === 0 });
  };

  clearModalSignature = () => {
    this.modalSignatureStrokes = [];
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.setState({ modalCanvasEmpty: true });
  };

  useModalSignature = () => {
    if (!this.signaturePadModal || this.signaturePadModal.isEmpty()) {
      return;
    }
    this.modalSignatureStrokes = this.getSignatureStrokes(this.signaturePadModal);
    this.inlineSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    const signatureDataUrl =
      this.getScaledSignatureDataUrl(this.signaturePadModal) ||
      this.signaturePadModal.getTrimmedCanvas().toDataURL("image/png");
    this.setState({
      signatureModalOpen: false,
      signature_type: "draw",
      signatureDrawn: true,
      signatureDataUrl,
      modalCanvasEmpty: this.modalSignatureStrokes.length === 0,
    }, () => {
      this.updateSignaturePreviewInAgreement(signatureDataUrl);
    });
  };

  async componentDidMount() {
    let apiHit = await agreementVerification(
      this.props.match.params.verification_token
    );
    //console.log("apiHit.data: ", apiHit.data);
    if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "Invalid Credientials"
    ) {
      //window.location.replace("/error");
      this.setState({
        errorMessage: "Invalid Credentials.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "no_record"
    ) {
      this.setState({
        errorMessage:
          "Oops! Your temporary URL has been expired or does not exists.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "already_signed"
    ) {
      this.setState({
        isAlreadySigned: true,
        errorMessage: "",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (apiHit.data.status === 200) {
      let client_signor_name =
        apiHit.data.user_data[0]["name"] ||
        apiHit.data.user_data[0]["comp_name"] ||
        apiHit.data.data[0][10] ||
        "";
      let objReplace = {
        resellerCompName: apiHit.data.reseller_data[0].reseller_comp,
        client_name: client_signor_name,
        client_title: apiHit.data.user_data[0]["title"] || "",
        client_comp_name: apiHit.data.user_data[0]["comp_name"],
        client_email: apiHit.data.user_data[0]["email"],
        client_address: apiHit.data.user_data[0]["address"]
          ? apiHit.data.user_data[0]["address"]
          : "N/A",
        client_city: apiHit.data.user_data[0]["city"]
          ? apiHit.data.user_data[0]["city"]
          : "N/A",
        client_state: apiHit.data.user_data[0]["state"]
          ? apiHit.data.user_data[0]["state"]
          : "N/A",
        client_zip: apiHit.data.user_data[0]["zip"]
          ? apiHit.data.user_data[0]["zip"]
          : "N/A",
        client_country: apiHit.data.user_data[0]["country"]
          ? apiHit.data.user_data[0]["country"]
          : "N/A",
        client_phone_no: this.formatPhoneNumber(
          apiHit.data.user_data[0]["phone"]
        ),
        vendor_signor_name: apiHit.data.reseller_data[0].reseller_name,
        vendor_signor_comp_name: apiHit.data.reseller_data[0].reseller_comp,
        vendor_signor_title: apiHit.data.reseller_data[0].reseller_title,
        vendor_signor_address: apiHit.data.reseller_data[0].reseller_address,
        vendor_signor_email: "N/A",
        vendor_signor_phone_no: apiHit.data.reseller_data[0].reseller_phone,
        vendor_signor_fax: "N/A",
        vendor_signor_city: apiHit.data.reseller_data[0].reseller_city,
        vendor_signor_state: apiHit.data.reseller_data[0].reseller_state,
        vendor_signor_zip: apiHit.data.reseller_data[0].reseller_zip,
        vendor_signor_comp_title: apiHit.data.reseller_data[0].reseller_comp,

        company_profile_name: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.name) || apiHit.data.company_profile.name || "N/A",
        company_profile_title: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.title) || apiHit.data.company_profile.title || "N/A",
        company_profile_address: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.address)
          ? `${apiHit.data.company_profile.all_signatories[0].address}`
          : (apiHit.data.company_profile.address
          ? `${apiHit.data.company_profile.address}`
          : "N/A"),
        company_profile_full_address: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.address)
          ? `${apiHit.data.company_profile.all_signatories[0].address}, ${apiHit.data.company_profile.all_signatories[0].city}, ${apiHit.data.company_profile.all_signatories[0].state}, ${apiHit.data.company_profile.all_signatories[0].zip}, ${apiHit.data.company_profile.all_signatories[0].country}`
          : (apiHit.data.company_profile.address
          ? `${apiHit.data.company_profile.address}, ${apiHit.data.company_profile.city}, ${apiHit.data.company_profile.state}, ${apiHit.data.company_profile.zip}, ${apiHit.data.company_profile.country}`
          : "N/A"),
        company_profile_city: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.city) || apiHit.data.company_profile.city || "N/A",
        company_profile_phone: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.phone) || apiHit.data.company_profile.phone || "N/A",
        company_profile_email: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.email) || apiHit.data.company_profile.email || "N/A",
        company_profile_state: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.state) || apiHit.data.company_profile.state || "N/A",
        company_profile_country: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.country) || apiHit.data.company_profile.country || "N/A",
        company_profile_zip: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.zip) || apiHit.data.company_profile.zip || "N/A",
        company_profile_sign: (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.signature_image) || apiHit.data.company_profile.sign || "N/A",
        company_profile_company_name:
          (apiHit.data.company_profile.all_signatories && apiHit.data.company_profile.all_signatories[0]?.company) || apiHit.data.company_profile.comp_name || "N/A",
      };
      let final_content = apiHit.data.data[0][1];
      final_content = REPLACECONTENTCLIENT(
        final_content,
        objReplace,
        ""
      ).replace(/\[\[IMG_VENDOR_SIGN\]\]/g, this.state.vendor_signature);
      this.setState({
        replacable_content: objReplace,
        agreementData: apiHit.data.data,
        errorMessage: "",
        final_content: final_content,
        bgColor: "white",
        defaultLoader: false,
        agreement_id: apiHit.data.data[0][0],
        agreement_type: apiHit.data.data[0][8],
        agreement_title: apiHit.data.data[0][9],
        agreement_accountno: apiHit.data.data[0][6],
        vendor_signature: apiHit.data.reseller_data[0].reseller_signature,
        tableLoaderAgreement: false,
        client_token: apiHit.data.token,
        client_accountno: apiHit.data.user_data[0]["accountno"],
        reseller_identifier:
          apiHit.data.reseller_data[0].reseller_domain_identifier,
        reseller_logo:
          ADMIN_URL + "files_data/logos/" + apiHit.data.reseller_data[0].logo,
        resellerData: apiHit.data.reseller_data || [],
        clientData: apiHit.data.user_data || [],
        signatureText: apiHit.data.user_data[0]["name"] || apiHit.data.user_data[0]["comp_name"] || "",
      }, () => {
        setTimeout(() => this.checkContentScrollable(), 500);
      });
    } else {
      this.setState({
        errorMessage:
          "Oops! There is some error while processing your request.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    }
  }

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  clear = () => {
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.setState({ signatureDrawn: false, modalCanvasEmpty: true, signatureDataUrl: "" });
    $("#divSig").hide();
    $(".clsimgSig").attr("src", "");
    $(".clsimgSig").hide();
    this.updateSignaturePreviewInAgreement("");
  };

  resetCanvas = () => {
    this.inlineSignatureStrokes = [];
    if (this.signaturePad) {
      this.resizeSignatureCanvas(this.signaturePad, 120);
      this.signaturePad.clear();
    }
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    this.props.agreementSigned();
  };

  isSaveDisabled = () => {
    if (this.state.loadingButton) return true;
    if (this.state.agreement_type === "accept" && this.state.is_checked !== "yes") return true;
    if (this.state.agreement_type === "esign") {
      if (this.state.signature_type === "draw" && !this.state.signatureDrawn) return true;
      if (this.state.signature_type === "choose" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "type" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "upload" && this.state.uploadedSignature === "") return true;
    }
    return false;
  };

  save = async () => {
    if (
      this.state.agreement_type === "accept" &&
      this.state.is_checked !== "yes"
    ) {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage:
          "For account activation and further processing. You must accept the agreement.",
      });
    } else if (
      this.state.agreement_type === "esign" &&
      this.state.signature_type === "draw" &&
      this.signaturePad && this.signaturePad.isEmpty() &&
      !this.state.signatureDataUrl
    ) {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage:
          "For account activation and further processing. You must sign the mandatory agreements.",
      });
    } else if (
      this.state.agreement_type === "esign" &&
      (this.state.signature_type === "choose" || this.state.signature_type === "type") &&
      this.state.signatureText === ""
    ) {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage: "Please enter the authorized person name.",
      });
    } else {
      if (this.state.agreement_type === "accept") {
        this.setState({
          loadingButton: true,
          errorMessage: "",
        });
        let content_div_id = "agreement_content_" + this.state.agreement_id;
        var final_content = document.getElementById(content_div_id).innerHTML;

        const apiHit = await saveVerificationAgreement(
          this.state.client_accountno,
          this.state.client_token,
          "",
          final_content.replace(
            "CLIENT SIGNATURE DATE SHOWN HERE",
            this.props.published_date
          ),
          this.state.agreement_id,
          this.state.agreement_accountno,
          this.state.vendor_signature,
          this.state.agreement_type
        );
        if (apiHit.data.status === 404) {
          window.$("#modalAlertError").modal("show");
          this.setState({
            errorMessage: "We are sorry, something went wrong try later.",
            loadingButton: false,
          });
        } else if (
          apiHit.data.status === 200 &&
          apiHit.data.data === "success"
        ) {
          this.handleAgreementSaveSuccess("The agreement has been accepted successfully.");
        }
      } else if (
        this.state.signature_type === "draw" ||
        this.state.signature_type === "choose" ||
        this.state.signature_type === "type" ||
        this.state.signature_type === "upload"
      ) {
        this.setState({ loadingButton: true, errorMessage: "" });
        await this.submitSignatoryDetails();
      }
    }
  };

  handleAgreementSaveSuccess = (message) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.resetTransientSignatureState();
    this.setState({
      successMessage: "",
      errorMessage: "",
      toastMessage: message,
      toastType: "success",
      toastTitle: this.state.agreement_type === "accept" ? "Agreement Accepted" : "Agreement Signed",
      loadingButton: false,
      is_checked: "",
      signatureDrawn: false,
      signatureText: "",
      uploadedSignature: "",
      signatureDataUrl: "",
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      signature_type: "draw",
      signatureColor: "#0F3A70",
      currentStep: 1,
      scrollProgress: 0,
      hasReachedEndOnce: false,
      consentChecked: false,
    });

    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  set_data = (agreement_content) => {
    this.setState({
      final_content: agreement_content,
    });
  };

  resetTransientSignatureState = () => {
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.value : target.value;
    const { name } = target;

    this.setState({ [name]: value }, () => {
      if (name === "signatureText") {
        requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
      }
    });
  };
  preview = () => {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      var data = this.getScaledSignatureDataUrl(this.signaturePad);
      $("#divSig").show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
    }
  };

  class_manage_link = (ids) => {
    return ids === this.state.activeTabIndex ? "nav-link active" : "nav-link";
  };

  class_manage_content = (ids) => {
    return ids === this.state.activeTabIndex ? "tab-pane active" : "tab-pane";
  };

  class_required = (ids) => {
    if (ids === 1) {
      return (
        <sup style={{ fontSize: "100%" }}>
          <small className="" style={{ color: "#e85347", fontSize: "100%" }}>
            *
          </small>
        </sup>
      );
    } else {
      return "";
    }
  };

  set_tabs = (ids) => {
    if (ids !== "") {
      return "#agreement" + ids;
    } else {
      return "tab-pane";
    }
  };

  set_tabs_content = (ids) => {
    if (ids !== "") {
      return "agreement" + ids;
    } else {
      return "tab-pane";
    }
  };

  show_agreement_content = async (
    ids,
    agreement_content,
    agreement_type,
    agreement_title
  ) => {
    let final_content = agreement_content;
    if (final_content !== "") {
      final_content = REPLACECONTENTCLIENT(
        agreement_content,
        this.state.replacable_content,
        ""
      ).replace(/\[\[IMG_VENDOR_SIGN\]\]/g, this.state.vendor_signature);
    }
    const tabIndex = this.state.agreementData.findIndex((a) => a[0] === ids);
    this.setState(
      {
        final_content: final_content,
        agreement_id: ids,
        agreement_type: agreement_type,
        agreement_title: agreement_title,
        activeTabIndex: tabIndex >= 0 ? tabIndex : 0,
        signatureDrawn: false,
        is_checked: "",
        signatureText: "",
        uploadedSignature: "",
        signatureDataUrl: "",
        signatureModalOpen: false,
        modalCanvasEmpty: true,
        signature_type: "draw",
        loadingButton: false,
        scrollProgress: 0,
        hasReachedEndOnce: false,
        consentChecked: false,
        currentStep: 1,
      },
      () => {
        if (this.signaturePad) this.signaturePad.clear();
        setTimeout(() => this.checkContentScrollable(), 300);
      }
    );
  };

  close_window = () => {
    const closeResult = window.close();
    if (
      closeResult === false ||
      window.location.href.indexOf("about:blank") === -1
    ) {
      const resellerIdentifier = this.state.reseller_identifier || auth.getResellerRegToken();
      const appBase = resellerIdentifier ? `${APP_LIVE_URL}${resellerIdentifier}` : APP_LIVE_URL.replace(/\/$/, '');
      try {
        const pendingOrderRefStr = localStorage.getItem('pendingOrderRef');
        if (pendingOrderRefStr) {
          const pendingOrderRef = JSON.parse(pendingOrderRefStr);
          const TWO_HOURS = 7200000;
          if (pendingOrderRef.service_id && (Date.now() - pendingOrderRef.timestamp) < TWO_HOURS) {
            localStorage.removeItem('pendingOrderRef');
            if (pendingOrderRef.form_accountno && pendingOrderRef.form_accountno !== '') {
              window.location.href = `${appBase}/client/client_form_submit/${pendingOrderRef.form_accountno}/${crypto.randomUUID()}/${pendingOrderRef.service_id}`;
            } else {
              const qty = pendingOrderRef.product_quantity || '1';
              const tempOrderNo = Math.floor(100000 + Math.random() * 900000);
              window.location.href = `${appBase}/client/EditSalesOrder/${tempOrderNo}/${pendingOrderRef.service_id}/?qty=${qty}`;
            }
            return;
          }
          localStorage.removeItem('pendingOrderRef');
        }
      } catch (_e) {
        localStorage.removeItem('pendingOrderRef');
      }
      window.location.href = `${appBase}/client`;
    }
  };

  updateSignatureType = (type) => {
    this.clear();
    this.updateSignaturePreviewInAgreement("");
    const nextState = {
      signature_type: type,
      signatureText:
        type === "choose" || type === "type"
          ? this.state.clientData?.[0]?.name || this.state.clientData?.[0]?.comp_name || ""
          : "",
      uploadedSignature: "",
      signatureDataUrl: "",
      signatureModalOpen: false,
      modalCanvasEmpty: true,
    };
    if (type === "type") {
      nextState.signatureClass = "'Dancing Script', cursive";
    }
    if (type === "choose") {
      nextState.signatureClass = "'Amita', cursive";
    }
    this.setState(nextState, () => {
      if (type === "draw") {
        setTimeout(() => this.resetCanvas(), 100);
      }
      if (type === "choose" || type === "type") {
        this.previewTypeSignatureInAgreement();
      }
    });
  };

  handleSignature = (family) => {
    this.setState({ signatureClass: family }, () => {
      requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
    });
  };

  handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        window.$("#modalAlertError").modal("show");
        this.setState({ errorMessage: "File size must be less than 2MB." });
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        const dataUrl = event.target.result;
        this.setState({ uploadedSignature: dataUrl }, () => {
          this.updateSignaturePreviewInAgreement(dataUrl);
        });
      };
      reader.readAsDataURL(file);
    }
  };

  submitSignatoryDetails = async () => {
    let { signatureText, signature_type } = this.state;
    this.setState({ loadingButton: true });
    if ((signature_type === "choose" || signature_type === "type") && signatureText === "") {
      window.$("#modalAlertError").modal("show");
      this.setState({ errorMessage: "Please enter the authorized person name.", loadingButton: false });
      return;
    }
    if (signature_type === "upload" && this.state.uploadedSignature === "") {
      window.$("#modalAlertError").modal("show");
      this.setState({ errorMessage: "Please upload a signature image.", loadingButton: false });
      return;
    }
    if (signature_type === "draw") {
      await this.saveDrawSignature();
    } else if (signature_type === "choose" || signature_type === "type") {
      await this.saveAsImage();
    } else if (signature_type === "upload") {
      await this.saveUploadedSignature();
    }
  };

  getDrawSignaturePayload = () => {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      return this.signaturePad.getTrimmedCanvas().toDataURL("image/png");
    }
    if (this.signaturePadModal && !this.signaturePadModal.isEmpty()) {
      return this.signaturePadModal.getTrimmedCanvas().toDataURL("image/png");
    }
    return this.state.signatureDataUrl || "";
  };

  saveDrawSignature = async () => {
    const data = this.getDrawSignaturePayload();
    if (!data) {
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "Unable to capture your signature. Please clear and re-draw your signature.",
        loadingButton: false,
      });
      return;
    }
    let content_div_id = "agreement_content_" + this.state.agreement_id;
    var final_content = document.getElementById(content_div_id).innerHTML;
    const drawSignatureText =
      this.state.clientData?.[0]?.name ||
      this.state.clientData?.[0]?.comp_name ||
      "Signature";
    const apiData = await saveChooseSignatureAgreementVerification(
      this.state.client_accountno,
      this.state.client_token,
      data,
      drawSignatureText,
      "draw",
      final_content.replace(
        "VENDOR SIGNATURE DATE SHOWN HERE",
        this.props.published_date
      ),
      this.state.agreement_id,
      this.state.vendor_signature,
      this.state.agreement_type,
      this.state.agreement_accountno
    );
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (apiData.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while processing your request.",
        loadingButton: false,
      });
    } else if (apiData.data.status === 200 && apiData.data.data === "success") {
      this.markClientPanelAsSigned("agreement_content_" + this.state.agreement_id, data);
      this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
    } else {
      this.setState({
        errorMessage: "There is some error while processing your request.",
        loadingButton: false,
      });
    }
  };

  saveAsImage = async () => {
    let { signatureText, signature_type } = this.state;
    const elementId = signature_type === "type" ? "typed-text-container" : "styled-text-container";
    const element = document.getElementById(elementId);
    if (element) {
      const origPosition = element.style.position;
      const origTop = element.style.top;
      const origLeft = element.style.left;
      element.style.position = "fixed";
      element.style.top = "0px";
      element.style.left = "-9999px";
      html2canvas(element, { scale: 2, backgroundColor: null }).then(
        async (canvas) => {
          element.style.position = origPosition;
          element.style.top = origTop;
          element.style.left = origLeft;
          const imgData = canvas.toDataURL("image/png");
          let content_div_id = "agreement_content_" + this.state.agreement_id;
          var final_content = document.getElementById(content_div_id).innerHTML;
          const apiData = await saveChooseSignatureAgreementVerification(
            this.state.client_accountno,
            this.state.client_token,
            imgData,
            signatureText,
            signature_type,
            final_content.replace(
              "VENDOR SIGNATURE DATE SHOWN HERE",
              this.props.published_date
            ),
            this.state.agreement_id,
            this.state.vendor_signature,
            this.state.agreement_type,
            this.state.agreement_accountno
          );
          if (
            apiData.data.status === 403 ||
            apiData.data.errors === "authentication missing" ||
            apiData.data.errors === "jwt expired"
          ) {
            auth.clientLogout();
          } else if (apiData.data.status === 404) {
            this.setState({
              errorMessage:
                "There is some error while processing your request.",
              successMessage: "",
              loadingButton: false,
            });
          } else if (
            apiData.data.status === 200 &&
            apiData.data.data === "success"
          ) {
            this.markClientPanelAsSigned("agreement_content_" + this.state.agreement_id, imgData);
            this.handleAgreementSaveSuccess("Agreement has been signed successfully.");
          } else {
            this.setState({
              errorMessage:
                "There is some error while processing your request.",
              successMessage: "",
              loadingButton: false,
            });
          }
        }
      );
    }
  };

  saveUploadedSignature = async () => {
    this.setState({ loadingButton: true, errorMessage: "" });
    let { uploadedSignature, signature_type } = this.state;
    if (uploadedSignature) {
      let content_div_id = "agreement_content_" + this.state.agreement_id;
      var final_content = document.getElementById(content_div_id).innerHTML;
      const apiData = await saveChooseSignatureAgreementVerification(
        this.state.client_accountno,
        this.state.client_token,
        uploadedSignature,
        "uploaded_signature",
        signature_type,
        final_content.replace("VENDOR SIGNATURE DATE SHOWN HERE", this.props.published_date),
        this.state.agreement_id,
        this.state.vendor_signature,
        this.state.agreement_type,
        this.state.agreement_accountno
      );
      if (apiData.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while processing your request.",
          loadingButton: false,
        });
      } else if (apiData.data.status === 200 && apiData.data.data === "success") {
        this.markClientPanelAsSigned("agreement_content_" + this.state.agreement_id, uploadedSignature);
        this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
      }
    }
  };

  openSignatureModal = () => {
    const inlineStrokes = this.getSignatureStrokes(this.signaturePad);
    const hasInlineSignature = inlineStrokes.length > 0;
    const fallbackStrokes = this.modalSignatureStrokes.length
      ? this.cloneSignatureStrokes(this.modalSignatureStrokes)
      : [];

    this.inlineSignatureStrokes = hasInlineSignature
      ? inlineStrokes
      : this.inlineSignatureStrokes;
    this.modalSignatureStrokes = hasInlineSignature
      ? this.cloneSignatureStrokes(inlineStrokes)
      : fallbackStrokes;

    const hasSavedDrawState = this.modalSignatureStrokes.length > 0;
    this.setState({ signatureModalOpen: true, modalCanvasEmpty: !hasSavedDrawState }, () => {
      setTimeout(() => {
        this.applySignatureStrokes(this.signaturePadModal, this.modalSignatureStrokes);
      }, 100);
    });
  };

  isElAtBottom = (el, threshold = 5) => {
    if (!el) {
      return false;
    }
    return el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
  };

  handleDocumentScroll = (e) => {
    const isFullscreenTarget =
      !!this.fullscreenScrollRef && e.target === this.fullscreenScrollRef;
    const fullscreenReadComplete =
      isFullscreenTarget && this.isElAtBottom(e.target, 80);
    const inlineAtBottom = !isFullscreenTarget && this.isElAtBottom(e.target);

    if (this.state.hasReachedEndOnce) {
      this.setState((prevState) => ({
        scrollProgress: 100,
        inlineAtBottom: isFullscreenTarget ? prevState.inlineAtBottom : inlineAtBottom,
        fullscreenAtBottom: isFullscreenTarget
          ? this.isElAtBottom(e.target, 80)
          : prevState.fullscreenAtBottom,
        fullscreenReadComplete:
          prevState.fullscreenReadComplete ||
          prevState.hasReachedEndOnce ||
          fullscreenReadComplete,
      }));
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - clientHeight > 0) {
      const progress = Math.round(
        (scrollTop / (scrollHeight - clientHeight)) * 100
      );
      const clamped = Math.min(progress, 100);
      const reachedEnd = isFullscreenTarget
        ? fullscreenReadComplete
        : clamped >= 100;
      this.setState((prevState) => ({
        scrollProgress: reachedEnd ? 100 : clamped,
        hasReachedEndOnce: prevState.hasReachedEndOnce || reachedEnd,
        inlineAtBottom: isFullscreenTarget ? prevState.inlineAtBottom : inlineAtBottom,
        fullscreenAtBottom: isFullscreenTarget
          ? this.isElAtBottom(e.target, 80)
          : prevState.fullscreenAtBottom,
        fullscreenReadComplete:
          prevState.fullscreenReadComplete || fullscreenReadComplete,
      }));
    } else if (isFullscreenTarget) {
      this.setState((prevState) => ({
        fullscreenAtBottom: this.isElAtBottom(e.target, 80),
        fullscreenReadComplete:
          prevState.fullscreenReadComplete || fullscreenReadComplete,
      }));
    }
  };

  checkContentScrollable = () => {
    const el = this.scrollContainerRef;
    if (el) {
      if (el.scrollHeight <= el.clientHeight + 5) {
        this.setState({ scrollProgress: 100, hasReachedEndOnce: true, inlineAtBottom: true });
      } else {
        this.setState({ inlineAtBottom: this.isElAtBottom(el) });
      }
    }
  };

  scrollAgreementToBottom = (ref) => {
    const el = ref || this.scrollContainerRef;
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  };

  recomputeScrollProgress = (el) => {
    if (!el) {
      return;
    }

    const isFullscreenTarget = el === this.fullscreenScrollRef;
    const fullscreenReadComplete =
      isFullscreenTarget && this.isElAtBottom(el, 80);

    if (this.state.hasReachedEndOnce) {
      this.setState((prevState) => ({
        scrollProgress: 100,
        inlineAtBottom: isFullscreenTarget ? prevState.inlineAtBottom : this.isElAtBottom(el),
        fullscreenAtBottom: isFullscreenTarget
          ? this.isElAtBottom(el, 80)
          : prevState.fullscreenAtBottom,
        fullscreenReadComplete:
          prevState.fullscreenReadComplete ||
          prevState.hasReachedEndOnce ||
          fullscreenReadComplete,
      }));
      return;
    }

    if (el.scrollHeight <= el.clientHeight + 5) {
      this.setState({
        scrollProgress: 100,
        hasReachedEndOnce: true,
        inlineAtBottom: isFullscreenTarget ? this.state.inlineAtBottom : true,
        fullscreenAtBottom: isFullscreenTarget
          ? this.isElAtBottom(el, 80)
          : this.state.fullscreenAtBottom,
        fullscreenReadComplete: isFullscreenTarget
          ? true
          : this.state.fullscreenReadComplete,
      });
      return;
    }

    const progress = Math.min(
      Math.round((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100),
      100
    );

    this.setState((prevState) => ({
      scrollProgress:
        isFullscreenTarget && fullscreenReadComplete ? 100 : progress,
      inlineAtBottom: isFullscreenTarget ? prevState.inlineAtBottom : this.isElAtBottom(el),
      fullscreenAtBottom: isFullscreenTarget
        ? this.isElAtBottom(el, 80)
        : prevState.fullscreenAtBottom,
      fullscreenReadComplete:
        prevState.fullscreenReadComplete || fullscreenReadComplete,
    }));
  };

  openReadFullscreen = () => {
    this.setState(
      {
        readFullscreenOpen: true,
        fullscreenAtBottom: false,
        fullscreenReadComplete: false,
      },
      () => {
        setTimeout(() => {
          this.recomputeScrollProgress(this.fullscreenScrollRef);
        }, 150);
      }
    );
  };

  closeReadFullscreen = () => {
    this.setState(
      { readFullscreenOpen: false, fullscreenReadComplete: false },
      () => {
        setTimeout(() => this.recomputeScrollProgress(this.scrollContainerRef), 150);
      }
    );
  };

  flashConsentAttention = () => {
    if (this.consentBoxRef) {
      this.consentBoxRef.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    this.setState({ highlightConsent: true });
    clearTimeout(this._consentHighlightTimer);
    this._consentHighlightTimer = setTimeout(() => {
      this.setState({ highlightConsent: false });
    }, 2200);
  };

  scrollToStepPanelIfNeeded = (force = false) => {
    if (this.stepPanelRef) {
      const rect = this.stepPanelRef.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (force || !isVisible) {
        this.stepPanelRef.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  continueEsignFromFullscreen = () => {
    if (!this.state.fullscreenReadComplete) {
      return;
    }

    const consentOk = this.state.consentChecked;
    this.setState(
      {
        readFullscreenOpen: false,
        scrollProgress: 100,
        hasReachedEndOnce: true,
      },
      () => {
        if (consentOk) {
          this.goToStep(2);
          setTimeout(() => this.scrollToStepPanelIfNeeded(true), 350);
        } else {
          this.setState({ currentStep: 1 }, () => {
            setTimeout(() => this.flashConsentAttention(), 200);
          });
        }
      }
    );
  };

  scrollToContinueIfNeeded = () => {
    if (this.continueBtnRef) {
      const rect = this.continueBtnRef.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (!isVisible) {
        this.continueBtnRef.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  _findClientSigElements = (contentDivId) => {
    const contentDiv = document.getElementById(contentDivId);
    if (!contentDiv) return null;
    const sigBlock = Array.from(contentDiv.querySelectorAll("div")).find(
      el => el.style.backgroundColor === "rgb(253, 248, 238)" ||
            (el.getAttribute("style") || "").includes("fdf8ee")
    );
    if (!sigBlock) return null;
    const flexRow = sigBlock.firstElementChild;
    if (!flexRow || flexRow.children.length < 2) return null;
    const clientPanel = flexRow.children[1];
    const body = clientPanel.children[1];
    if (!body || body.children.length < 2) return null;
    return { sigBlock, clientPanel, signatureBox: body.children[1] };
  };

  markClientPanelAsSigned = (contentDivId, dataUrl) => {
    const els = this._findClientSigElements(contentDivId);
    if (!els) return;
    const { clientPanel, signatureBox } = els;

    if (dataUrl) {
      signatureBox.innerHTML = `<img src="${dataUrl}" style="max-width:100%;max-height:80px;object-fit:contain;display:block;margin:0 auto;" alt="Signature" />`;
    }
    signatureBox.style.border = "1.5px solid rgba(22,163,74,0.3)";
    signatureBox.style.background = "rgba(22,163,74,0.04)";
    clientPanel.style.border = "1.5px solid rgba(22,163,74,0.35)";

    const header = clientPanel.firstElementChild;
    if (header) {
      header.style.background = "rgba(22,163,74,0.06)";
      header.style.borderBottom = "1px solid rgba(22,163,74,0.15)";
      const dot = header.querySelector("div");
      if (dot) dot.style.background = "#16a34a";
      const spans = header.querySelectorAll("span");
      if (spans[0]) spans[0].style.color = "#16a34a";
      if (spans[1]) { spans[1].style.color = "#16a34a"; spans[1].textContent = "✓ Signed"; }
    }

    const sigLabel = signatureBox.nextElementSibling;
    if (sigLabel) {
      sigLabel.style.color = "rgba(22,163,74,0.5)";
      sigLabel.style.borderTop = "1px solid rgba(22,163,74,0.15)";
    }

    const today = new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    clientPanel.querySelectorAll("span").forEach(span => {
      if (span.textContent.trim().toLowerCase().includes("pending")) {
        span.textContent = today;
        span.style.fontStyle = "normal";
        span.style.color = "#3A3D4A";
        span.style.fontWeight = "600";
      }
    });
  };

  updateSignaturePreviewInAgreement = (dataUrl) => {
    const contentDivId = "agreement_content_" + this.state.agreement_id;
    const contentDiv = document.getElementById(contentDivId);
    if (!contentDiv) return;

    const els = this._findClientSigElements(contentDivId);
    if (els) {
      const { signatureBox } = els;
      if (dataUrl) {
        signatureBox.innerHTML = `<img src="${dataUrl}" style="max-width:100%;max-height:80px;object-fit:contain;display:block;margin:0 auto;" alt="Signature" />`;
      } else {
        signatureBox.innerHTML = `<span style="font-size:17px;font-family:'Dancing Script',cursive;color:#B8B3AD;font-style:italic;">Signature</span>`;
      }
      return;
    }

    const sigImg = contentDiv.querySelector("#imgSig");
    if (sigImg) {
      if (dataUrl) {
        sigImg.removeAttribute("onerror");
        sigImg.src = dataUrl;
        sigImg.style.cssText = "display:block;width:100%;max-width:230px;height:auto;object-fit:contain;";
      } else {
        sigImg.src = "";
        sigImg.style.display = "none";
      }
    }
  };

  previewTypeSignatureInAgreement = () => {
    const { signature_type, signatureText, signatureClass } = this.state;
    if ((signature_type !== "type" && signature_type !== "choose") || !signatureText) return;
    const font = signature_type === "type"
      ? "'Dancing Script', cursive"
      : (signatureClass || "'Dancing Script', cursive");
    const els = this._findClientSigElements("agreement_content_" + this.state.agreement_id);
    if (!els) return;
    els.signatureBox.innerHTML = `<span style="font-size:24px;font-family:${font};color:#3A3D4A;">${signatureText}</span>`;
  };

  goToStep = (step) => {
    if (step === 2) {
      if (!this.state.hasReachedEndOnce) {
        return;
      }
      if (!this.state.consentChecked) {
        return;
      }
    }
    if (step === 1) {
      this.inlineSignatureStrokes = [];
      this.modalSignatureStrokes = [];
      if (this.signaturePad) this.signaturePad.clear();
      if (this.signaturePadModal) this.signaturePadModal.clear();
      this.updateSignaturePreviewInAgreement("");
      this.setState({
        currentStep: 1,
        signatureDrawn: false,
        modalCanvasEmpty: true,
        signatureDataUrl: "",
        uploadedSignature: "",
        signatureText: "",
        signature_type: "draw",
      });
      return;
    }
    this.setState({ currentStep: step });
  };

  sanitizeFileNamePart = (value, fallback) => {
    const cleaned = (value || "")
      .toString()
      .trim()
      .replace(/[^a-zA-Z0-9\s_-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
    return cleaned || fallback;
  };

  getAgreementDownloadBaseName = () => {
    const accountNo = this.sanitizeFileNamePart(
      this.state.agreement_accountno,
      "account"
    );
    const agreementName = this.sanitizeFileNamePart(
      this.state.agreement_title,
      "agreement"
    );
    return `agreement_${accountNo}_${agreementName}`;
  };

  clearUploadedSignature = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ uploadedSignature: "" }, () => {
      const input = document.getElementById("signatureUploadInput");
      if (input) {
        input.value = "";
      }
      this.updateSignaturePreviewInAgreement("");
    });
  };

  downloadPdf = async () => {
    const documentTitle = this.getAgreementDownloadBaseName();
    this.setState({ downloading: true, downloadingFormat: "PDF" });
    try {
      const contentDivId = "agreement_content_" + this.state.agreement_id;
      const contentDiv = document.getElementById(contentDivId);
      if (!contentDiv) {
        this.setState({ downloading: false, downloadingFormat: "" });
        return;
      }
      const response = await downloadAgreementPdf(
        this.state.client_accountno,
        this.state.client_token,
        contentDiv.innerHTML,
        this.state.agreement_title || documentTitle
      );
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = documentTitle + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("PDF download error:", error);
    } finally {
      this.setState({ downloading: false, downloadingFormat: "" });
    }
  };

  downloadTxt = () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) return;
    const documentTitle = this.getAgreementDownloadBaseName();
    this.setState({ downloading: true, downloadingFormat: "TXT" });
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = activeTabPane.innerHTML || "";
    const sigBlock = Array.from(tempDiv.querySelectorAll("div")).find(
      el => (el.getAttribute("style") || "").includes("background:#fdf8ee")
    );
    if (sigBlock) {
      const flexDiv = sigBlock.firstElementChild;
      const parts = [
        "<p>============================================</p>",
        "<p>SIGNATURES</p>",
        "<p>============================================</p>",
      ];
      if (flexDiv) {
        Array.from(flexDiv.children).forEach(card => {
          const headerDiv = card.firstElementChild;
          const contentDiv = card.children[1];
          const headerSpans = headerDiv ? Array.from(headerDiv.querySelectorAll("span")) : [];
          const sectionLabel = headerSpans.map(s => s.textContent.trim()).filter(Boolean).join(" \u2013 ");
          if (sectionLabel) parts.push("<p>&nbsp;</p><p><b>" + sectionLabel.toUpperCase() + "</b></p>");
          if (contentDiv) {
            const nameDiv = contentDiv.firstElementChild;
            if (nameDiv && nameDiv.textContent.trim()) {
              parts.push("<p>Organization: " + nameDiv.textContent.trim() + "</p>");
            }
            const fieldContainer = Array.from(contentDiv.children).find(
              el => (el.getAttribute("style") || "").includes("flex-direction:column")
            );
            if (fieldContainer) {
              Array.from(fieldContainer.children).forEach(row => {
                const spans = Array.from(row.querySelectorAll("span"));
                if (spans.length >= 2) {
                  const label = spans[0].textContent.trim();
                  const value = spans[1].textContent.trim();
                  if (label) parts.push("<p>" + label + ": " + value + "</p>");
                }
              });
            }
          }
        });
      }
      parts.push("<p>&nbsp;</p><p>============================================</p>");
      const replacer = document.createElement("div");
      replacer.innerHTML = parts.join("");
      sigBlock.parentNode.replaceChild(replacer, sigBlock);
    }
    const content = tempDiv.innerHTML;
    const cleanedHtml = content
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
      .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<[^>]+>/g, "");
    const decoder = document.createElement("textarea");
    decoder.innerHTML = cleanedHtml;
    const text = decoder.value
      .replace(/\u00A0/g, " ")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .replace(/\r\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
    const blob = new Blob([text], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = documentTitle + ".txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.setState({ downloading: false, downloadingFormat: "" });
  };

  renderIcon = (name, size = 16, color = "currentColor", extraStyle = {}) => {
    const s = { width: size, height: size, ...extraStyle };
    const icons = {
      edit: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
      cross: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
      check: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
      undo: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg>,
      lock: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
      download: <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
      "file-pdf": <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15v-2h2a1 1 0 110 2H9z"/></svg>,
      "file-doc": <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
      "file-text": <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
    };
    return icons[name] || null;
  };

  renderStepPanel = () => {
    const { currentStep, scrollProgress, agreement_type } = this.state;
    return (
      <div ref={(el) => { this.stepPanelRef = el; }} style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", height: "100%", display: "flex", flexDirection: "column", position: "sticky", top: "80px" }}>
        <div className="card-inner" style={{ padding: "24px" }}>
          {currentStep === 1 ? (
            <div>
              {/* Step Header with pill badge */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "4px 11px", marginBottom: "10px" }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR }}>Step 1 of 2</span>
                </div>
                <h5 style={{ fontWeight: "700", color: "#364a63", marginBottom: "4px", fontSize: "16px" }}>
                  Review &amp; <em style={{ fontStyle: "italic" }}>verify</em>
                </h5>
                <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>Confirm the parties and read the document</p>
              </div>
              <hr style={{ margin: "0 0 16px 0", border: "none", borderTop: "1px solid #e5e9f2" }} />

              {/* Parties label */}
              <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.1em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Parties</div>

              {this.state.resellerData.length > 0 && (
                <div style={{ background: "#f8f9fa", border: "1px solid #e5e9f2", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px" }}>
                  <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.09em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Disclosing Party</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#364a63", marginBottom: "8px" }}>{this.state.resellerData[0].reseller_comp}</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    {this.state.resellerData[0].reseller_address && (
                      <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        {`${this.state.resellerData[0].reseller_address}, ${this.state.resellerData[0].reseller_city}, ${this.state.resellerData[0].reseller_state} ${this.state.resellerData[0].reseller_zip}`}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {this.state.clientData.length > 0 && (
                <div style={{ background: "#f8f9fa", border: "1px solid #e5e9f2", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px" }}>
                  <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.09em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Receiving Party - Signing Now</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#364a63", marginBottom: "8px" }}>{this.state.clientData[0]["name"]}</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                      {this.state.clientData[0]["comp_name"]}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                      {this.state.clientData[0]["email"]}
                    </div>
                  </div>
                </div>
              )}

              {/* Consent Checkbox */}
              <div
                ref={(el) => { this.consentBoxRef = el; }}
                className={this.state.highlightConsent ? "agr-consent-attention" : ""}
                style={{ border: this.state.consentChecked ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2", borderRadius: "10px", padding: "12px 13px", marginBottom: "12px", backgroundColor: this.state.consentChecked ? `${THEME_COLOR}08` : "#fff", transition: "all 0.2s ease", display: "flex", alignItems: "flex-start", gap: "10px", cursor: "pointer" }}
                onClick={() => {
                  const newVal = !this.state.consentChecked;
                  this.setState({ consentChecked: newVal }, () => {
                    if (newVal) this.scrollToContinueIfNeeded();
                  });
                }}
              >
                <div style={{ width: "18px", height: "18px", borderRadius: "5px", border: this.state.consentChecked ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5", backgroundColor: this.state.consentChecked ? THEME_COLOR : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px", transition: "all 0.15s ease" }}>
                  {this.state.consentChecked && (<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>)}
                </div>
                <div style={{ fontSize: "11px", lineHeight: "1.55", color: "#526484" }}>
                  I confirm I am{" "}<strong style={{ color: "#364a63" }}>{this.state.clientData.length > 0 ? this.state.clientData[0]["name"] : "the authorized signee"}</strong>, authorised to sign on behalf of my organisation, and agree to sign electronically with the same legal effect as a handwritten signature.
                </div>
              </div>

              {/* Scroll warning */}
              {!this.state.hasReachedEndOnce && (
                <div style={{ background: "#FFF8E1", border: "1px solid #FFD54F", borderRadius: "8px", padding: "9px 12px", display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px", fontSize: "11px", color: "#8D6E63" }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  Please scroll through the entire agreement to continue.{" "}<strong>{scrollProgress}% read</strong>
                </div>
              )}

              {/* Footer */}
              <div className="agr-panel-footer" style={{ borderTop: "1px solid #e5e9f2", paddingTop: "12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: "#8094ae" }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                  Verified via secure link
                </div>
                <button
                  className="btn btn-sm agr-panel-continue-btn"
                  ref={(el) => { this.continueBtnRef = el; }}
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "8px 18px", borderRadius: "8px", backgroundColor: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_COLOR : "#c4cdd5", color: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_TEXT_COLOR : "#fff", cursor: this.state.hasReachedEndOnce && this.state.consentChecked ? "pointer" : "not-allowed", fontSize: "12px", fontWeight: "600", border: "none", transition: "all 0.2s ease" }}
                  onClick={() => this.goToStep(2)}
                  disabled={!this.state.hasReachedEndOnce || !this.state.consentChecked}
                >
                  Continue
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </button>
              </div>
            </div>
          ) : (
            /* STEP 2: Sign & Submit */
            <div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "4px 11px", marginBottom: "10px" }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                  <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR }}>Step 2 of 2</span>
                </div>
                <h5 style={{ fontWeight: "700", color: "#364a63", marginBottom: "4px", fontSize: "16px" }}>
                  {agreement_type === "accept" ? <>Accept this <em style={{ fontStyle: "italic" }}>agreement</em></> : <>Add your <em style={{ fontStyle: "italic" }}>signature</em></>}
                </h5>
                {agreement_type !== "accept" && (
                  <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>Choose how you'd like to sign</p>
                )}
              </div>

              {agreement_type === "esign" ? (
                <>
                  <div id="signature_div" style={{ width: "100%", float: "none" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "6px", marginBottom: "16px" }}>
                      <div onClick={() => this.updateSignatureType("draw")} style={{ padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s", border: this.state.signature_type === "draw" || this.state.signature_type === "" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2", backgroundColor: this.state.signature_type === "draw" || this.state.signature_type === "" ? `${THEME_COLOR}0a` : "#fff" }}>
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "draw" || this.state.signature_type === "" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#526484" }}>Draw</span>
                      </div>
                      <div onClick={() => this.updateSignatureType("choose")} style={{ padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s", border: this.state.signature_type === "choose" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2", backgroundColor: this.state.signature_type === "choose" ? `${THEME_COLOR}0a` : "#fff" }}>
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "choose" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "choose" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "choose" ? THEME_COLOR : "#526484" }}>Type Name</span>
                      </div>
                      <div onClick={() => this.updateSignatureType("upload")} style={{ gridColumn: "span 2", padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s", border: this.state.signature_type === "upload" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2", backgroundColor: this.state.signature_type === "upload" ? `${THEME_COLOR}0a` : "#fff" }}>
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "upload" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "upload" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "upload" ? THEME_COLOR : "#526484" }}>Upload image</span>
                      </div>
                    </div>

                    <div className="tab-content">
                      {/* Choose Style Pane */}
                      <div className={this.state.signature_type === "choose" ? "tab-pane active" : "tab-pane"} id="tabItem5">
                        <div className="form-group mb-3">
                          <MutextField required id="signatureText" name="signatureText" type="text" label="Authorized Person Name" inputProps={{ maxLength: 30 }} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={this.state.signatureText} onChange={this.handleChange} helperText="" variant="outlined" fullWidth autoComplete="new-password" />
                        </div>
                        <h6 style={{ fontSize: "12px", fontWeight: "600", color: "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Type Name</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
                          {[{ name: "Dancing Script", label: "Handwritten", value: "'Dancing Script', cursive" }, { name: "Caveat", label: "Cursive", value: "'Caveat', cursive" }, { name: "Sacramento", label: "Classic", value: "'Sacramento', cursive" }].map((font, index) => (
                            <div key={index} onClick={() => this.handleSignature(font.value)} style={{ padding: "14px 16px", borderRadius: "8px", border: this.state.signatureClass === font.value ? `2px solid ${THEME_COLOR}` : "2px solid transparent", backgroundColor: this.state.signatureClass === font.value ? `${THEME_COLOR}08` : "#fff", cursor: "pointer", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span style={{ fontFamily: font.value, fontSize: "24px", color: "#364a63" }}>{this.state.signatureText || "Your Signature"}</span>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signatureClass === font.value ? THEME_COLOR : "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px" }}>{font.label}</span>
                                {this.state.signatureClass === font.value && (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>)}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div id="styled-text-container" style={{ fontFamily: this.state.signatureClass, fontSize: "32px", width: "100%", maxWidth: "480px", height: "80px", background: "transparent", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000", overflow: "hidden", position: "fixed", top: "-9999px", left: "0px" }}>
                          {this.state.signatureText || "Your Signature"}
                        </div>
                      </div>

                      {/* Draw Pane */}
                      <div className={this.state.signature_type === "draw" || this.state.signature_type === "" ? "tab-pane active" : "tab-pane"} id="tabItem6">
                        <Row>
                          <Col sm={12}>
                            <div id="divSig" style={{ display: "none" }}>
                              <div className="mb-4"><img src="" className="clsimgSig" height="100" width="200" onError={(e) => (e.target.style.display = "none")} /></div>
                            </div>
                            <div><strong>Signature</strong></div>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "1%" }}>
                          <Col sm={12} style={{ position: "relative" }}>
                            <div style={{ position: "relative", border: "2px dashed #dbdfea", borderRadius: "8px", overflow: "hidden", backgroundColor: "#fafafa" }}>
                              <button type="button" style={{ position: "absolute", top: "6px", right: "6px", zIndex: 2, borderRadius: "4px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", border: "1px solid #dbdfea", cursor: "pointer", color: "#526484" }} onClick={() => this.openSignatureModal()} title="Sign in full screen">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 00-2 2v3"/><path d="M21 8V5a2 2 0 00-2-2h-3"/><path d="M3 16v3a2 2 0 002 2h3"/><path d="M16 21h3a2 2 0 002-2v-3"/></svg>
                              </button>
                              <div style={{ height: "120px", position: "relative" }}>
                                <SignatureCanvas
                                  clearOnResize={false}
                                  penColor={this.state.signatureColor}
                                  minWidth={this.state.penWidth}
                                  maxWidth={this.state.penWidth + 0.5}
                                  canvasProps={{ style: { width: "100%", height: "100%", display: this.state.signatureDataUrl ? "none" : "block" } }}
                                  velocityFilterWeight={0.7}
                                  throttle={50}
                                  onBegin={this.handleInlineSignatureBegin}
                                  onEnd={this.handleInlineSignatureEnd}
                                  ref={(ref) => {
                                    this.signaturePad = ref;
                                    if (ref && !this.state.signatureDataUrl) {
                                      setTimeout(() => this.resizeSignatureCanvas(ref, 120), 0);
                                    }
                                  }}
                                />
                                {this.state.signatureDataUrl && (
                                  <img src={this.state.signatureDataUrl} alt="Signature" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "contain", objectPosition: "center", padding: "8px" }} />
                                )}
                                {!this.state.signatureDrawn && !this.state.signatureDataUrl && (
                                  <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", pointerEvents: "none", color: "#adb5bd" }}>
                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", margin: "0 auto 4px" }}><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                                    <span style={{ fontSize: "12px" }}>Draw your signature here</span>
                                  </div>
                                )}
                                <div style={{ position: "absolute", bottom: "20px", left: "10%", right: "10%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                              </div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", background: "#f8f9fc", border: "1px solid #e5e9f2", borderTop: "none", borderRadius: "0 0 10px 10px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                  {this.penSizes.map((s, idx) => (
                                    <button key={idx} type="button" title={s.label} onClick={() => this.setState({ penWidth: s.penWidth })} style={{ width: "24px", height: "24px", borderRadius: "50%", background: this.state.penWidth === s.penWidth ? "rgba(15,58,112,0.08)" : "#fff", border: this.state.penWidth === s.penWidth ? "1.5px solid #0F3A70" : "1.5px solid #e5e9f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0, transition: "all 0.13s" }}>
                                      <div style={{ width: s.dotSize + "px", height: s.dotSize + "px", borderRadius: "50%", background: "#526484" }} />
                                    </button>
                                  ))}
                                  <div style={{ width: "1px", height: "16px", backgroundColor: "#e5e9f2" }} />
                                  {this.inkColors.map((c, idx) => (
                                    <div key={idx} onClick={() => this.setState({ signatureColor: c.value })} title={c.name} style={{ width: "18px", height: "18px", borderRadius: "50%", backgroundColor: c.value, cursor: "pointer", border: this.state.signatureColor === c.value ? "2px solid #526484" : "2px solid transparent", boxShadow: this.state.signatureColor === c.value ? "0 0 0 2px white" : "none", transition: "all 0.13s" }} />
                                  ))}
                                </div>
                                <button type="button" style={{ fontFamily: "inherit", fontSize: "11px", fontWeight: "600", color: "#e85347", background: "transparent", border: "1px solid rgba(176,42,42,0.25)", borderRadius: "7px", padding: "4px 9px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", transition: "all 0.13s" }} onClick={() => this.clear()}>
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#e85347" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 100-9.49"/></svg> Clear
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Upload Pane */}
                      <div className={this.state.signature_type === "upload" ? "tab-pane active" : "tab-pane"} id="tabItemUpload">
                        <div style={{ border: "2px dashed #dbdfea", borderRadius: "8px", padding: "30px 20px", textAlign: "center", backgroundColor: "#f8f9fc", cursor: "pointer", transition: "all 0.2s ease", position: "relative" }} onClick={() => { document.getElementById("signatureUploadInput").click(); }} onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.backgroundColor = `${THEME_COLOR}08`; }} onDragLeave={(e) => { e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; }} onDrop={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; if (e.dataTransfer.files && e.dataTransfer.files[0]) { this.handleSignatureUpload({ target: { files: e.dataTransfer.files } }); } }}>
                          <input type="file" id="signatureUploadInput" accept="image/png,image/jpeg,image/jpg" style={{ display: "none" }} onChange={this.handleSignatureUpload} />
                          {this.state.uploadedSignature ? (
                            <div>
                              <img src={this.state.uploadedSignature} alt="Uploaded Signature" style={{ maxWidth: "100%", maxHeight: "120px", marginBottom: "12px", border: "1px solid #e5e9f2", borderRadius: "4px", padding: "8px", backgroundColor: "#fff" }} />
                              <div>
                                <button className="btn btn-sm btn-outline-danger" onClick={this.clearUploadedSignature} style={{ marginTop: "8px", display: "inline-flex", alignItems: "center", gap: "6px", padding: "6px 12px" }}>
                                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
                                  <span>Remove</span>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "#e5e9f2", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 8px" }}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>
                              <p style={{ fontSize: "13px", fontWeight: "600", color: "#364a63", marginBottom: "4px" }}>Click to upload or drag &amp; drop</p>
                              <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>PNG or JPG (max 2MB)</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="signature-action-footer" style={{ padding: "14px 18px", borderTop: "1px solid #e5e9f2" }}>
                      <div className="d-flex align-items-center signature-action-legal" style={{ gap: "6px", fontSize: "11px", color: "#8094ae", marginBottom: "10px", flexWrap: "nowrap" }}>
                        {this.renderIcon("lock", 14, "currentColor")}
                        <span>Legally binding &bull; 256-bit encrypted</span>
                      </div>
                      <div className="d-flex signature-action-buttons" style={{ gap: "8px", justifyContent: "flex-end" }}>
                        <button className="signature-action-btn" onClick={() => this.goToStep(1)} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", background: "#fff", color: "#526484", border: "1px solid #e5e9f2", transition: "all 0.15s" }}>
                          Back
                        </button>
                        {this.state.button_submit_loader || this.state.loadingButton ? (
                          <button className="signature-action-btn" type="button" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, background: THEME_COLOR, color: THEME_TEXT_COLOR, border: "none", opacity: 0.45, cursor: "not-allowed" }} disabled>
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span><span>Wait...</span>
                          </button>
                        ) : (
                          <button className="signature-action-btn" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", border: "none", background: THEME_COLOR, color: THEME_TEXT_COLOR, transition: "all 0.15s" }} onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn">
                            {this.renderIcon("check", 13, "currentColor")}
                            Sign and Continue
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {/* ACCEPT TYPE */}
              {agreement_type === "accept" ? (
                <div id="signature_div" style={{ width: "100%" }}>
                  <div style={{ border: this.state.is_checked === "yes" ? "1px solid #1ee0ac" : "1px solid #e5e9f2", borderRadius: "8px", padding: "20px", marginBottom: "20px", backgroundColor: this.state.is_checked === "yes" ? "#edfff8" : "#f8f9fc", transition: "all 0.2s ease", display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }} onClick={() => { const newVal = this.state.is_checked === "yes" ? "" : "yes"; this.setState({ is_checked: newVal }); }}>
                    <div style={{ width: "22px", height: "22px", borderRadius: "4px", border: this.state.is_checked === "yes" ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5", backgroundColor: this.state.is_checked === "yes" ? THEME_COLOR : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "2px", transition: "all 0.15s ease" }}>
                      {this.state.is_checked === "yes" && this.renderIcon("check", 13, "#fff")}
                    </div>
                    <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#364a63" }}>
                      <strong>I accept the {this.state.agreement_title}</strong>
                      <div style={{ fontSize: "12px", color: "#8094ae", marginTop: "4px" }}>By checking this box, you confirm that you have read and agree to the terms outlined above.</div>
                    </div>
                  </div>
                  <div style={{ paddingTop: "16px", borderTop: "1px solid #e5e9f2" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "flex-end", alignItems: "center" }}>
                      <button className="signature-action-btn" onClick={() => this.goToStep(1)} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", background: "#fff", color: "#526484", border: "1px solid #e5e9f2", transition: "all 0.15s" }}>Back</button>
                      {this.state.loadingButton ? (
                        <button className="signature-action-btn" type="button" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, background: THEME_COLOR, color: THEME_TEXT_COLOR, border: "none", opacity: 0.45, cursor: "not-allowed" }} disabled>
                          <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span><span>Wait...</span>
                        </button>
                      ) : (
                        <button className="signature-action-btn" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", border: "none", background: THEME_COLOR, color: THEME_TEXT_COLOR, transition: "all 0.15s" }} onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn">
                          {this.renderIcon("check", 13, "currentColor")}
                          Accept &amp; Continue
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  handlePrint = () => {
    // Target the div element by ID
    const activeTabPane = document.querySelector(".tab-pane.active");
    const activeTabId = activeTabPane.id;
    const printableElement = document.getElementById(activeTabId);

    // Check if the element exists
    if (printableElement) {
      // Open a new window for printing
      const printWindow = window.open("", "_blank");

      // Append the content of the div to the new window for printing
      printWindow.document.write(printableElement.innerHTML);

      // Trigger the print dialog for the new window
      printWindow.print();

      // Close the new window after printing
      printWindow.close();
    } else {
      console.error("Element not found: contentToPrint");
    }
  };

  handleDownload = () => {
    const agreementContent = document.querySelector(".tab-agreement_content");
    if (!agreementContent) {
      console.error("Agreement content not found");
      return;
    }
    const documentTitle = this.getAgreementDownloadBaseName();

    // Helper function to replace signature block placeholders with data
    const replaceSignaturePlaceholders = (content) => {
      let processed = content;

      // Replace company placeholder
      processed = processed.replace(/\[\[COMPANY_NAME\]\]/g, this.state.replacable_content?.company_profile_company_name || "Company Name");
      processed = processed.replace(/\[\[COMPANY_SIGNOR_NAME\]\]/g, this.state.replacable_content?.company_profile_name || "Signatory Name");
      processed = processed.replace(/\[\[COMPANY_SIGNOR_TITLE\]\]/g, this.state.replacable_content?.company_profile_title || "Title");

      // Replace client placeholder
      processed = processed.replace(/\[\[CLIENT_COMPANY_NAME\]\]/g, this.state.replacable_content?.client_comp_name || "Client Company");
      processed = processed.replace(/\[\[CLIENT_SIGNOR_NAME\]\]/g, this.state.replacable_content?.client_name || "Client Name");
      processed = processed.replace(/\[\[CLIENT_SIGNOR_TITLE\]\]/g, this.state.replacable_content?.client_title || "Title");

      return processed;
    };

    // Helper function to sanitize content - strips HTML/CSS and decodes entities
    const sanitizeContent = (content) => {
      if (!content || typeof content !== "string") {
        console.error("Invalid content provided");
        return "";
      }

      // First replace signature block placeholders with actual data
      let processedContent = replaceSignaturePlaceholders(content);

      // Create a temporary div to parse HTML safely
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = processedContent;

      // Remove all script and style tags
      const scripts = tempDiv.querySelectorAll("script, style");
      scripts.forEach(script => script.remove());

      // Get the text content
      let text = tempDiv.innerText || tempDiv.textContent || "";

      return text
        .replace(/\u00A0/g, " ") // Convert non-breaking spaces (&nbsp;)
        .replace(/[\u200B-\u200D\uFEFF]/g, "") // Remove zero-width characters
        .replace(/\r\n/g, "\n") // Normalize line endings
        .replace(/\n{3,}/g, "\n\n") // Collapse multiple newlines
        .trim();
    };

    // Create a text run with custom options
    const createTextRun = (text, options = {}) => {
      return new TextRun({
        text: text || "",
        font: "Arial",
        size: 22,
        ...options,
      });
    };

    // Create a paragraph with alignment and spacing
    const createParagraph = (text, options = {}) => {
      return new Paragraph({
        alignment: options.alignment || "left",
        spacing: {
          before: 150,
          after: 150,
          line: 280,
        },
        children: [createTextRun(text, options.textOptions)],
      });
    };

    // Create a bold title paragraph (Main Title)
    const createMainTitle = (text) => {
      return new Paragraph({
        alignment: "center",
        spacing: {
          before: 200,
          after: 150,
        },
        children: [
          new TextRun({
            text: text,
            bold: true,
            size: 32,
            font: "Arial",
          }),
        ],
      });
    };

    // Create a bold section title paragraph (Heading)
    const createBoldTitle = (text) => {
      return createParagraph(text, {
        alignment: "left",
        textOptions: {
          bold: true,
          size: 28,
        },
      });
    };

    // Create a fully right-aligned section
    const createRightAlignedSection = (lines) => {
      const children = lines.map((line) => createTextRun(line, { break: 1 }));
      return new Paragraph({
        alignment: "right",
        spacing: {
          before: 150,
          after: 150,
        },
        children,
      });
    };

    // Create a table dynamically
    const createTable = (rows) => {
      const tableRows = rows.map((row) => {
        const cells = row.split("|").map(
          (cell) =>
            new TableCell({
              children: [createParagraph(cell.trim())],
            })
        );
        return new TableRow({ children: cells });
      });

      return new Table({
        rows: tableRows,
        width: {
          size: 100,
          type: WidthType.PERCENTAGE,
        },
      });
    };

    // Process content dynamically
    const processContent = (content) => {
      const sanitizedContent = sanitizeContent(content);
      const lines = sanitizedContent
        .split(/\r?\n/)
        .filter((line) => line.trim());
      const docElements = [];
      let tableRows = [];
      let isFirstLine = true;
      let licensorBlockStarted = false;

      lines.forEach((line, index) => {
        // If the first line, treat it as the main title
        if (isFirstLine) {
          docElements.push(createMainTitle(line));
          isFirstLine = false;
          return;
        }

        // Check for table rows (contains "|")
        if (line.includes("|")) {
          tableRows.push(line);
        } else {
          // If previous table rows exist, create a table
          if (tableRows.length) {
            docElements.push(createTable(tableRows));
            tableRows = [];
          }

          // Handle the last section (LICENSOR block)
          if (line.includes("LICENSOR:")) {
            const licensorBlock = lines.slice(index); // Get the entire block starting from "LICENSOR:"
            docElements.push(createRightAlignedSection(licensorBlock));
            licensorBlockStarted = true; // Mark that LICENSOR block has started
            return; // Skip further processing of the remaining lines
          }

          // Skip processing if we are within the LICENSOR block
          if (licensorBlockStarted) return;

          // Add titles for lines starting with numbers
          if (/^\d+\./.test(line)) {
            docElements.push(createBoldTitle(line));
          } else {
            docElements.push(createParagraph(line));
          }
        }
      });

      // Add remaining table rows
      if (tableRows.length) {
        docElements.push(createTable(tableRows));
      }

      return docElements;
    };

    const content = agreementContent.innerHTML;
    const docElements = processContent(content);

    // Create and download the document
    const doc = new Document({
      sections: [
        {
          properties: {
            page: {
              margin: {
                top: convertInchesToTwip(0.5),
                right: convertInchesToTwip(0.5),
                bottom: convertInchesToTwip(0.5),
                left: convertInchesToTwip(0.5),
              },
            },
          },
          children: docElements,
        },
      ],
    });

    Packer.toBlob(doc)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${documentTitle}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error generating document:", error);
      });
  };


  render() {
    return (
      <div className="nk-content unsignedagreements" style={{ padding: 0 }}>
        {ReactDOM.createPortal(
          <div className="agr-toast-container">
            <NotificationToast
              message={this.state.toastMessage}
              type={this.state.toastType}
              title={this.state.toastTitle}
              onDismiss={() => this.setState({ toastMessage: "" })}
            />
          </div>,
          document.body
        )}
        <style>{`
          .nk-content-body > .nk-block-head:first-child { padding-bottom: .1rem; }
          .cav-stepper-bar-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding: 10px 0; gap: 8px; flex-wrap: wrap; }
          @media (max-width: 575px) {
            .cav-stepper-bar-row { flex-wrap: nowrap !important; gap: 4px !important; padding: 6px 0 !important; }
            .cav-stepper-pill { flex: 1 1 0; min-width: 0; overflow: hidden; }
            .cav-stepper-step-item { padding: 5px 8px !important; gap: 4px !important; flex: 1 1 0; min-width: 0; }
            .cav-stepper-step-label { font-size: 10px !important; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
            .cav-stepper-download-btn { padding: 6px 9px !important; font-size: 11px !important; flex-shrink: 0 !important; gap: 4px !important; }
            .cav-stepper-fullscreen-btn { padding: 6px 9px !important; font-size: 11px !important; flex-shrink: 0 !important; gap: 4px !important; }
            .cav-fs-header { padding: 12px 14px !important; }
            .cav-fs-actions { width: 100%; flex-shrink: 1 !important; }
            .cav-fs-actions button { flex: 1 1 0; min-width: 0; white-space: nowrap; }
            .cav-fs-bottombar { padding: 10px 14px !important; gap: 10px !important; }
            .cav-fs-bottombar button { padding: 8px 12px !important; font-size: 12px !important; }
          }
          @media (max-width: 575.98px) {
            .signature-action-footer {
              align-items: stretch !important;
            }
            .signature-action-legal {
              width: 100%;
              justify-content: center;
              text-align: center;
            }
            .signature-action-buttons {
              width: 100% !important;
              display: flex !important;
              flex-wrap: nowrap !important;
              gap: 8px !important;
            }
            .signature-action-btn {
              flex: 1 1 0;
              min-width: 0;
            }
          }
        `}</style>
        <div className="container-fluid px-0 agr-page-container">
          <div className="nk-content-inner unsigned-page-wrapper">
            <div className="brand-logo pb-0 text-center">
              {this.state.reseller_logo && this.state.reseller_logo !== "" ? (
                <a href="/" className="logo-link">
                  <img
                    className="logo-light logo-img logo-img-lg"
                    src={this.state.reseller_logo}
                    alt="logo"
                  />
                  <img
                    className="logo-dark logo-img logo-img-lg"
                    src={this.state.reseller_logo}
                    alt="logo-dark"
                  />
                </a>
              ) : (
                <a href="/" className="logo-link">
                  <img
                    className="logo-light logo-img logo-img-lg"
                    src={LOGO}
                    alt="logo"
                  />
                  <img
                    className="logo-dark logo-img logo-img-lg"
                    src={LOGO}
                    alt="logo-dark"
                  />
                </a>
              )}
            </div>
            <div className="nk-content-body">
              {/* <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between-md g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">Agreement Signing</h3>
                    <div className="nk-block-des text-soft">
                      <p>Review and sign your pending agreements</p>
                    </div>
                  </div>
                </div>
              </div> */}
              {this.state.isAlreadySigned ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", padding: "40px 16px" }}>
                  <div style={{ width: "100%", maxWidth: "480px", textAlign: "center" }}>
                    {/* Green check icon */}
                    <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: "rgba(22,163,74,0.1)", border: "2px solid rgba(22,163,74,0.25)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px" }}>
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                    </div>

                    {/* Title */}
                    <h3 style={{ fontWeight: "700", color: "#364a63", fontSize: "22px", marginBottom: "10px" }}>Agreement Signed</h3>
                    <p style={{ fontSize: "14px", color: "#526484", lineHeight: "1.7", marginBottom: "28px" }}>
                      This agreement has already been signed successfully.<br />No further action is required.
                    </p>

                  </div>
                </div>
              ) : this.state.errorMessage !== "" && this.state.agreementData.length === 0 ? (
                <div className="nk-wrap justify-center">
                  <div className="nk-content ">
                    <div className="nk-block nk-block-middle wide-md mx-auto">
                      <div className="nk-block-content nk-error-ld text-center">
                        <img className="nk-error-gfx" src={PROMO_A} alt="" />
                        <div className="wide-xs mx-auto">
                          <h3 className="nk-error-title">
                            {this.state.errorMessage}
                          </h3>
                          <p className="nk-error-text">
                            We are very sorry for inconvenience. It looks like
                            you are trying to access a page that either has been
                            deleted or never existed.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <>
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                  <center>
                    <a
                      onClick={this.close_window}
                      className="btn btn-primary mt-2"
                      style={{ color: "#fff", cursor: "pointer" }}
                    >
                      Close Window
                    </a>
                  </center>
                </>
              ) : null}
              {this.state.tableLoaderAgreement === true ? (
                tableLoaderAgreement()
              ) : (
                <div className="nk-block">
                  <div className="row g-gs mx-0" style={{ marginTop: 0 }}>
                    <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 px-0">
                      <div className="nk-block nk-block-lg" style={{ marginBottom: 0 }}>
                        {this.state.agreementData.length > 0 ? (
                          <>
                            {/* DOCUMENT NAVIGATION HEADER */}
                            {(() => {
                              const { agreementData, activeTabIndex } = this.state;
                              const activeAgreement = agreementData[activeTabIndex] || [];
                              const totalDocs = agreementData.length;
                              const hasPrev = activeTabIndex > 0;
                              const hasNext = activeTabIndex < totalDocs - 1;
                              const isRequired = activeAgreement[3] === 1;
                              return (
                                <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", padding: "14px 60px", borderBottom: "1px solid #e5e9f2", marginBottom: "4px" }}>
                                  {/* Left arrow */}
                                  <button
                                    onClick={() => {
                                      if (hasPrev) {
                                        const prev = agreementData[activeTabIndex - 1];
                                        this.show_agreement_content(prev[0], prev[1], prev[8], prev[9]);
                                      }
                                    }}
                                    disabled={!hasPrev}
                                    style={{ position: "absolute", left: "8px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", padding: "6px 8px", cursor: hasPrev ? "pointer" : "default", color: hasPrev ? "#526484" : "#c4cdd5", borderRadius: "6px", display: "flex", alignItems: "center", transition: "color 0.15s" }}
                                    title="Previous document"
                                  >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                                  </button>

                                  {/* Center: doc name + counter */}
                                  <div style={{ textAlign: "center", lineHeight: 1.3 }}>
                                    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#526484" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                      <span style={{ fontSize: "14px", fontWeight: "700", color: "#1c2b46", textDecoration: "underline", textUnderlineOffset: "2px" }}>
                                        {activeAgreement[9] || this.state.agreement_title}
                                      </span>
                                      {isRequired && (
                                        <sup style={{ color: "#e85347", fontSize: "12px", fontWeight: "700", lineHeight: 1 }}>*</sup>
                                      )}
                                    </div>
                                    <div style={{ fontSize: "11px", color: "#8094ae", marginTop: "2px" }}>
                                      Document {activeTabIndex + 1} of {totalDocs}
                                      <span style={{ display: "inline-block", width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#8094ae", marginLeft: "6px", verticalAlign: "middle" }} />
                                    </div>
                                  </div>

                                  {/* Right arrow */}
                                  <button
                                    onClick={() => {
                                      if (hasNext) {
                                        const next = agreementData[activeTabIndex + 1];
                                        this.show_agreement_content(next[0], next[1], next[8], next[9]);
                                      }
                                    }}
                                    disabled={!hasNext}
                                    style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", padding: "6px 8px", cursor: hasNext ? "pointer" : "default", color: hasNext ? "#526484" : "#c4cdd5", borderRadius: "6px", display: "flex", alignItems: "center", transition: "color 0.15s" }}
                                    title="Next document"
                                  >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                                  </button>
                                </div>
                              );
                            })()}

                            {/* TWO COLUMN LAYOUT */}
                            <div className="row mx-0" style={{ display: "flex", alignItems: "stretch", marginTop: "14px" }}>
                              {/* LEFT: Document Panel */}
                              <div className="col-lg-9 col-xxl-8 px-0 agr-doc-col" style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", overflow: "clip", flex: 1, display: "flex", flexDirection: "column" }}>
                                  <div key={this.state.agreement_accountno} style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0" }}>
                                    <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #e5e9f2" }}>
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px", flexWrap: "wrap" }}>
                                        <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "5px 12px", flexShrink: 0 }}>
                                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                          <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR, letterSpacing: "0.06em" }}>AGREEMENT</span>
                                        </div>
                                        <div className="agr-header-actions" style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                                          <button
                                            className="btn btn-sm btn-dim btn-outline-light agr-fullscreen-btn"
                                            onClick={this.openReadFullscreen}
                                            title="Read in full screen"
                                            style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 13px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                                          >
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                                            <span className="agr-btn-label">Full Screen</span>
                                          </button>
                                          <button
                                            className="btn btn-sm btn-dim btn-outline-light agr-download-btn"
                                            onClick={() => this.setState({ downloadModalOpen: true })}
                                            title="Download Agreement"
                                            style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 13px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                                          >
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                            <span className="agr-btn-label">Download</span>
                                          </button>
                                        </div>
                                      </div>
                                      <h3 style={{ marginBottom: "6px" }}>
                                        {this.state.agreement_title}
                                      </h3>
                                      {this.state.resellerData.length > 0 && this.state.clientData.length > 0 && (
                                        <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>
                                          Between <strong style={{ color: "#526484" }}>{this.state.resellerData[0].reseller_comp}</strong> &amp;{" "}
                                          <strong style={{ color: "#526484" }}>{this.state.clientData[0]["comp_name"] || this.state.clientData[0]["name"]}</strong>
                                        </p>
                                      )}
                                    </div>

                                    <div style={{ position: "relative", padding: "0 24px" }}>
                                      <div
                                        className="tab-content tab-agreement_content"
                                        style={{ maxHeight: "calc(100vh - 150px)", overflowY: "auto", marginTop: "0" }}
                                        onScroll={this.handleDocumentScroll}
                                        ref={(el) => { this.scrollContainerRef = el; }}
                                      >
                                        <div className="agr-scroll-banner-blink" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "14px", background: `${THEME_COLOR}0a`, border: `1px solid ${THEME_COLOR}26`, borderRadius: "12px", padding: "14px 16px", margin: "12px 2px 16px" }}>
                                          <div className="agr-banner-icon" style={{ width: "40px", height: "40px", borderRadius: "10px", background: THEME_COLOR, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={THEME_TEXT_COLOR} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                                          </div>
                                          <div style={{ minWidth: 0 }}>
                                            <div className="agr-banner-title" style={{ fontSize: "14px", fontWeight: 700, color: "#364a63", marginBottom: "2px" }}>Scroll down to read the full agreement</div>
                                            <div className="agr-banner-sub" style={{ fontSize: "12px", color: "#526484" }}>Continue becomes available after you've read to the end</div>
                                          </div>
                                        </div>
                                        {this.state.agreementData.map((agreementscontent, i) => (
                                          <div className={this.class_manage_content(i)} id={this.set_tabs_content(agreementscontent[6])} key={`agrcont${i}`}>
                                            <div
                                              id={`agreement_content_${agreementscontent[0]}`}
                                              dangerouslySetInnerHTML={{
                                                __html: REPLACECONTENTCLIENT(
                                                  agreementscontent[1],
                                                  this.state.replacable_content,
                                                  ""
                                                ).replace(
                                                  /\[\[IMG_VENDOR_SIGN\]\]/g,
                                                  this.state.vendor_signature
                                                ),
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </div>
                                      {!this.state.inlineAtBottom && (
                                        <button
                                          className="btn btn-sm"
                                          onClick={() => {
                                            this.scrollAgreementToBottom(this.scrollContainerRef);
                                            setTimeout(() => this.flashConsentAttention(), 700);
                                          }}
                                          title="Jump to bottom of agreement"
                                          style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", bottom: "14px", display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "999px", cursor: "pointer", background: "#fff", border: "1px solid #dbdfea", boxShadow: "0 3px 10px rgba(0,0,0,0.12)", fontSize: "12px", fontWeight: "600", color: "#526484", zIndex: 2 }}
                                        >
                                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                                          <span className="agr-btn-label">Jump to bottom</span>
                                        </button>
                                      )}
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        padding: "10px 24px",
                                        background: "#f8f9fa",
                                        borderTop: "1px solid #e5e9f2",
                                        marginTop: "0",
                                      }}
                                    >
                                      <div style={{ flex: 1, height: "3px", backgroundColor: "#dbdfea", borderRadius: "10px", overflow: "hidden" }}>
                                        <div
                                          style={{
                                            height: "100%",
                                            width: this.state.scrollProgress + "%",
                                            backgroundColor: this.state.hasReachedEndOnce ? "#1ee0ac" : THEME_COLOR,
                                            borderRadius: "10px",
                                            transition: "width 0.12s ease",
                                          }}
                                        />
                                      </div>
                                      <span style={{ fontSize: "11px", fontWeight: "600", color: "#8094ae", minWidth: "26px", textAlign: "right" }}>
                                        {this.state.scrollProgress}%
                                      </span>
                                      {this.state.hasReachedEndOnce && (
                                        <span style={{ fontSize: "11px", color: "#1ee0ac", fontWeight: "600", display: "flex", alignItems: "center", gap: "3px" }}>
                                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                          Fully read
                                        </span>
                                      )}
                                      <div style={{ width: "1px", height: "14px", background: "#dbdfea", margin: "0 4px", flexShrink: 0 }} />
                                      <button
                                        className="btn btn-sm"
                                        style={{ display: "flex", alignItems: "center", gap: "5px", flexShrink: 0, padding: "5px 11px", borderRadius: "6px", cursor: "pointer", background: "white", border: "1px solid #dbdfea", fontSize: "11px", fontWeight: "600", color: "#526484", transition: "all 0.13s", whiteSpace: "nowrap" }}
                                        onClick={() => this.setState({ downloadModalOpen: true })}
                                        title="Export Agreement"
                                      >
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                        Export
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* RIGHT: Side Panel */}
                              <div className="col-lg-3 col-xxl-4 px-0 agr-panel-col">
                                {this.renderStepPanel()}
                              </div>
                            </div>

                            {this.state.currentStep === 1 && (
                              <div className="agr-mobile-continue">
                                <button
                                  onClick={() => {
                                    if (!this.state.hasReachedEndOnce) {
                                      return;
                                    }
                                    if (!this.state.consentChecked) {
                                      this.flashConsentAttention();
                                      return;
                                    }
                                    this.goToStep(2);
                                    setTimeout(() => this.scrollToStepPanelIfNeeded(true), 200);
                                  }}
                                  style={{
                                    width: "100%",
                                    padding: "12px",
                                    borderRadius: "10px",
                                    border: "none",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    background: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_COLOR : "#c4cdd5",
                                    color: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_TEXT_COLOR : "#fff",
                                    cursor: this.state.hasReachedEndOnce && this.state.consentChecked ? "pointer" : "not-allowed",
                                  }}
                                >
                                  Continue
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                                </button>
                              </div>
                            )}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {this.state.readFullscreenOpen && (() => {
                const activeAgreement =
                  this.state.agreementData[this.state.activeTabIndex] ||
                  this.state.agreementData[0];
                if (!activeAgreement) {
                  return null;
                }

                const continueLabel =
                  this.state.agreement_type === "accept"
                    ? "Continue to Accept"
                    : "Continue to E-Sign";
                const fullscreenContinueEnabled =
                  this.state.fullscreenReadComplete;
                const continueBtnStyle = {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "7px",
                  padding: "9px 18px",
                  borderRadius: "8px",
                  fontSize: "13px",
                  fontWeight: "700",
                  border: "none",
                  background: fullscreenContinueEnabled ? THEME_COLOR : "#c4cdd5",
                  color: "#fff",
                  cursor: fullscreenContinueEnabled ? "pointer" : "not-allowed",
                  whiteSpace: "nowrap",
                  opacity: fullscreenContinueEnabled ? 1 : 0.8,
                };

                return (
                  <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9998, backgroundColor: "#fff", display: "flex", flexDirection: "column" }}>
                    <div className="cav-fs-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", background: "#fff", borderBottom: "1px solid #e5e9f2", flexShrink: 0, gap: "10px", flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-dim btn-outline-light"
                          onClick={this.closeReadFullscreen}
                          title="Exit full screen"
                          style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                        >
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                          Exit
                        </button>
                        <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#364a63", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }} title={activeAgreement[9] || this.state.agreement_title}>
                          {activeAgreement[9] || this.state.agreement_title}
                        </h5>
                      </div>
                      <div className="cav-fs-actions" style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                        <button
                          className="btn btn-sm btn-dim btn-outline-light"
                          onClick={() => this.setState({ downloadModalOpen: true })}
                          title="Download Agreement"
                          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "8px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                        >
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                          Download
                        </button>
                        <button
                          onClick={this.continueEsignFromFullscreen}
                          disabled={!fullscreenContinueEnabled}
                          title="Continue"
                          style={continueBtnStyle}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                          {continueLabel}
                        </button>
                      </div>
                    </div>

                    <div
                      className="tab-agreement_content"
                      style={{ flex: 1, overflowY: "auto", background: "#fff" }}
                      onScroll={this.handleDocumentScroll}
                      ref={(el) => {
                        this.fullscreenScrollRef = el;
                      }}
                    >
                      <div style={{ padding: "20px 16px 60px" }}>
                        {!this.state.fullscreenReadComplete && (
                          <div className="agr-scroll-banner-blink" style={{ display: "flex", alignItems: "center", gap: "16px", background: `${THEME_COLOR}0a`, border: `1px solid ${THEME_COLOR}26`, borderRadius: "12px", padding: "16px 20px", marginBottom: "24px" }}>
                            <div style={{ width: "44px", height: "44px", borderRadius: "10px", background: THEME_COLOR, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={THEME_TEXT_COLOR} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: "15px", fontWeight: 700, color: "#364a63", marginBottom: "2px" }}>Scroll down to read the full agreement</div>
                              <div style={{ fontSize: "13px", color: "#526484" }}>Continue becomes available after you've read to the end</div>
                            </div>
                          </div>
                        )}

                        {this.state.agreementData.map((agreementscontent, i) => (
                          <div className={this.class_manage_content(i)} id={`agreementfs${agreementscontent[6]}`} key={`agrfscont${i}`}>
                            <div
                              id={`agreement_content_fs_${agreementscontent[0]}`}
                              dangerouslySetInnerHTML={{
                                __html: REPLACECONTENTCLIENT(
                                  agreementscontent[1],
                                  this.state.replacable_content,
                                  ""
                                ).replace(
                                  /\[\[IMG_VENDOR_SIGN\]\]/g,
                                  this.state.vendor_signature
                                ),
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    {!this.state.fullscreenAtBottom && (
                      <button
                        className="btn btn-sm"
                        onClick={() => this.scrollAgreementToBottom(this.fullscreenScrollRef)}
                        title="Jump to bottom of agreement"
                        style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", bottom: "80px", display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "999px", cursor: "pointer", background: "#fff", border: "1px solid #dbdfea", boxShadow: "0 3px 10px rgba(0,0,0,0.12)", fontSize: "12px", fontWeight: "600", color: "#526484", zIndex: 2 }}
                      >
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                        Jump to bottom
                      </button>
                    )}

                    <div className="cav-fs-bottombar" style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 18px", background: "#f8f9fa", borderTop: "1px solid #e5e9f2", flexShrink: 0 }}>
                      <div style={{ flex: 1, height: "3px", backgroundColor: "#dbdfea", borderRadius: "10px", overflow: "hidden" }}>
                        <div
                          style={{
                            height: "100%",
                            width: this.state.scrollProgress + "%",
                            backgroundColor: this.state.hasReachedEndOnce ? "#1ee0ac" : THEME_COLOR,
                            borderRadius: "10px",
                            transition: "width 0.12s ease",
                          }}
                        />
                      </div>
                      <span style={{ fontSize: "11px", fontWeight: "600", color: "#8094ae", minWidth: "26px", textAlign: "right" }}>
                        {this.state.scrollProgress}%
                      </span>
                      {this.state.fullscreenReadComplete && (
                        <span style={{ fontSize: "11px", color: "#1ee0ac", fontWeight: "600", display: "flex", alignItems: "center", gap: "3px", whiteSpace: "nowrap" }}>
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                          Fully read
                        </span>
                      )}
                      <div style={{ width: "1px", height: "14px", background: "#dbdfea", margin: "0 4px", flexShrink: 0 }} />
                      <button
                        onClick={this.continueEsignFromFullscreen}
                        disabled={!fullscreenContinueEnabled}
                        title="Continue"
                        style={continueBtnStyle}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                        {continueLabel}
                      </button>
                    </div>
                  </div>
                );
              })()}

              {/* SIGNATURE ZOOM MODAL */}
              {this.state.signatureModalOpen && (
                <div
                  style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
                  onClick={(e) => { if (e.target === e.currentTarget) this.setState({ signatureModalOpen: false }); }}
                >
                  <div style={{ backgroundColor: "#fff", borderRadius: "12px", width: "100%", maxWidth: "750px", boxShadow: "0 8px 30px rgba(0,0,0,0.25)", overflow: "hidden" }}>
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: "1px solid #e5e9f2" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ width: "36px", height: "36px", borderRadius: "10px", backgroundColor: `${THEME_COLOR}14`, border: `1px solid ${THEME_COLOR}33`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {this.renderIcon("edit", 16, THEME_COLOR)}
                        </div>
                        <div>
                          <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#364a63" }}>Draw your signature</h5>
                          <span style={{ fontSize: "13px", color: "#8094ae" }}>Use your finger, stylus, or mouse</span>
                        </div>
                      </div>
                      <button type="button" onClick={() => this.setState({ signatureModalOpen: false })} style={{ width: "32px", height: "32px", borderRadius: "50%", border: "1px solid #dbdfea", backgroundColor: "#f5f6fa", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#526484", padding: 0 }}>
                        {this.renderIcon("cross", 14)}
                      </button>
                    </div>
                    {/* Canvas Area */}
                    <div style={{ padding: "20px 24px" }}>
                      <div style={{ border: "1px solid #e5e9f2", borderRadius: "8px", height: "300px", position: "relative", backgroundColor: "#fafbfc" }}>
                        <SignatureCanvas
                          clearOnResize={false}
                          penColor={this.state.signatureColor}
                          minWidth={this.state.penWidth}
                          maxWidth={this.state.penWidth + 0.5}
                          canvasProps={{ 
                            style: { width: "100%", height: "100%", display: "block" }
                          }}
                          velocityFilterWeight={0.7}
                          throttle={50}
                          ref={(ref) => { 
                            this.signaturePadModal = ref; 
                            if (ref) {
                              setTimeout(() => this.resizeSignatureCanvas(ref, 300), 0);
                            }
                          }}
                          onBegin={this.handleModalSignatureBegin}
                          onEnd={this.handleModalSignatureEnd}
                        />
                        {this.state.modalCanvasEmpty && (
                          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                            <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#e4e7eb", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
                              {this.renderIcon("edit", 22, "#8094ae")}
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: 500, color: "#526484" }}>Draw your signature here</div>
                            <div style={{ fontSize: "13px", color: "#8094ae", marginTop: "4px" }}>Use finger on mobile &bull; Mouse on desktop</div>
                          </div>
                        )}
                        <div style={{ position: "absolute", bottom: "50px", left: "8%", right: "8%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                      </div>
                      {/* Pen sizes + Ink colors + Undo/Clear */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {this.penSizes.map((s, idx) => (
                            <button
                              key={idx}
                              type="button"
                              title={s.label}
                              onClick={() => this.setState({ penWidth: s.penWidth })}
                              style={{
                                width: "28px", height: "28px", borderRadius: "50%",
                                background: this.state.penWidth === s.penWidth ? "rgba(15,58,112,0.08)" : "#fff",
                                border: this.state.penWidth === s.penWidth ? "1.5px solid #0F3A70" : "1.5px solid #e5e9f2",
                                cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                                padding: 0, transition: "all 0.13s",
                              }}
                            >
                              <div style={{ width: (s.dotSize + 1) + "px", height: (s.dotSize + 1) + "px", borderRadius: "50%", background: "#526484" }} />
                            </button>
                          ))}
                          <div style={{ width: "1px", height: "18px", backgroundColor: "#e5e9f2" }} />
                          {this.inkColors.map((clr, idx) => (
                            <div
                              key={idx}
                              onClick={() => this.setState({ signatureColor: clr.value })}
                              title={clr.name}
                              style={{
                                width: "20px", height: "20px", borderRadius: "50%",
                                backgroundColor: clr.value, cursor: "pointer",
                                border: this.state.signatureColor === clr.value ? "2px solid #526484" : "2px solid transparent",
                                boxShadow: this.state.signatureColor === clr.value ? "0 0 0 2px white" : "none",
                                transition: "all 0.13s",
                              }}
                            />
                          ))}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <button
                            type="button"
                            style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
                            onClick={this.undoModalSignature}
                          >
                            {this.renderIcon("undo", 14)} Undo
                          </button>
                          <button
                            type="button"
                            style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
                            onClick={this.clearModalSignature}
                          >
                            Clear all
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Footer */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 24px", borderTop: "1px solid #e5e9f2", backgroundColor: "#fafbfc" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#8094ae", fontSize: "12px" }}>
                        {this.renderIcon("lock", 14)}
                        <span>Legally binding &bull; 256-bit encrypted</span>
                      </div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button className="btn btn-outline-light" onClick={() => this.setState({ signatureModalOpen: false })} style={{ borderRadius: "6px", padding: "8px 20px" }}>Cancel</button>
                        <button className="btn" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, borderRadius: "6px", padding: "8px 20px", opacity: this.state.modalCanvasEmpty ? 0.45 : 1, cursor: this.state.modalCanvasEmpty ? "not-allowed" : "pointer" }} onClick={this.useModalSignature} disabled={this.state.modalCanvasEmpty}>
                          {this.renderIcon("check", 14, "currentColor", { marginRight: "4px" })}
                          Use this signature
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* DOWNLOAD MODAL */}
              {this.state.downloadModalOpen && (
                <div
                  style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
                  onClick={(e) => { if (e.target === e.currentTarget && !this.state.downloading) this.setState({ downloadModalOpen: false }); }}
                >
                  <div style={{ backgroundColor: "#fff", borderRadius: "16px", width: "100%", maxWidth: "400px", boxShadow: "0 8px 30px rgba(0,0,0,0.18)", overflow: "hidden", position: "relative" }}>
                    {this.state.downloading && (
                      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255,255,255,0.85)", zIndex: 2, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "16px" }}>
                        <div className="spinner-border" style={{ color: THEME_COLOR, width: "2.5rem", height: "2.5rem" }} role="status" />
                        <div style={{ marginTop: "12px", fontSize: "14px", fontWeight: 500, color: "#364a63" }}>Preparing your download…</div>
                      </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #e5e9f2" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div style={{ width: "36px", height: "36px", borderRadius: "10px", backgroundColor: `${THEME_COLOR}14`, border: `1px solid ${THEME_COLOR}33`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {this.renderIcon("download", 16, THEME_COLOR)}
                        </div>
                        <div>
                          <h5 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#364a63" }}>Download Agreement</h5>
                          <span style={{ fontSize: "14px", color: "#8094ae" }}>{this.state.agreement_title}</span>
                        </div>
                      </div>
                      <button type="button" onClick={() => { if (!this.state.downloading) this.setState({ downloadModalOpen: false }); }} style={{ width: "30px", height: "30px", borderRadius: "50%", border: "1px solid #dbdfea", backgroundColor: "#f5f6fa", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#526484", padding: 0 }}>
                        {this.renderIcon("cross", 12)}
                      </button>
                    </div>
                    <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: "10px" }}>
                      <button
                        type="button"
                        disabled={this.state.downloading}
                        onClick={() => this.downloadPdf()}
                        onMouseOver={(e) => { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}08`; }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = "#e5e9f2"; e.currentTarget.style.background = "#fff"; }}
                        style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 16px", borderRadius: "10px", border: "1px solid #e5e9f2", backgroundColor: "#fff", cursor: "pointer", transition: "all 0.15s", width: "100%", textAlign: "left" }}
                      >
                        <div style={{ width: "38px", height: "38px", borderRadius: "8px", backgroundColor: "#ff63631a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          {this.renderIcon("file-pdf", 18, "#e85347")}
                        </div>
                        <div><div style={{ fontSize: "14px", fontWeight: 600, color: "#364a63" }}>PDF Document</div><div style={{ fontSize: "12px", color: "#8094ae" }}>Best for printing and archiving</div></div>
                      </button>
                      <button
                        type="button"
                        disabled={this.state.downloading}
                        onClick={() => this.handleDownload()}
                        onMouseOver={(e) => { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}08`; }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = "#e5e9f2"; e.currentTarget.style.background = "#fff"; }}
                        style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 16px", borderRadius: "10px", border: "1px solid #e5e9f2", backgroundColor: "#fff", cursor: "pointer", transition: "all 0.15s", width: "100%", textAlign: "left" }}
                      >
                        <div style={{ width: "38px", height: "38px", borderRadius: "8px", backgroundColor: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          {this.renderIcon("file-doc", 18, "#2563eb")}
                        </div>
                        <div><div style={{ fontSize: "14px", fontWeight: 600, color: "#364a63" }}>Word Document (.docx)</div><div style={{ fontSize: "12px", color: "#8094ae" }}>Best for editing in Microsoft Word</div></div>
                      </button>
                      <button
                        type="button"
                        disabled={this.state.downloading}
                        onClick={() => this.downloadTxt()}
                        onMouseOver={(e) => { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}08`; }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = "#e5e9f2"; e.currentTarget.style.background = "#fff"; }}
                        style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 16px", borderRadius: "10px", border: "1px solid #e5e9f2", backgroundColor: "#fff", cursor: "pointer", transition: "all 0.15s", width: "100%", textAlign: "left" }}
                      >
                        <div style={{ width: "38px", height: "38px", borderRadius: "8px", backgroundColor: "#8094ae1a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          {this.renderIcon("file-text", 18, "#8094ae")}
                        </div>
                        <div><div style={{ fontSize: "14px", fontWeight: 600, color: "#364a63" }}>Plain Text</div><div style={{ fontSize: "12px", color: "#8094ae" }}>Simple text format</div></div>
                      </button>
                    </div>
                    <div style={{ padding: "0 24px 18px" }}>
                      <button type="button" onClick={() => { if (!this.state.downloading) this.setState({ downloadModalOpen: false }); }} style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #dbdfea", backgroundColor: "#f5f6fa", color: "#526484", fontSize: "13px", fontWeight: 500, cursor: "pointer" }}>Cancel</button>
                    </div>
                  </div>
                </div>
              )}

              {/* SUCCESS MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHide();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                        <h4 className="nk-modal-title">
                          {this.state.successMessage}
                        </h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            You've successfully signed{" "}
                            <strong>Agreement</strong>
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHide();
                            }}
                          >
                            OK
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SUCCESS MODAL End */}
              {/* ERROR MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlertError">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                        <h4 className="nk-modal-title">Unable to Upload!</h4>
                        <div className="nk-modal-text">
                          <p className="lead">{this.state.errorMessage}</p>
                        </div>
                        <div className="nk-modal-action mt-5">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-light"
                            data-dismiss="modal"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ERROR MODAL END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
